import axios from "axios"
import { Capacitor } from "@capacitor/core"

const webHttp = axios.create({
  baseURL: process.env.VUE_APP_WEB_BASE_URL,
  withCredentials: true,
  headers: {
    "X-Client": Capacitor.isNativePlatform() ? "capacitor" : "web",
    "X-Client-Version": process.env.VUE_APP_VERSION,
  },
})

export default webHttp
